import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./driverTheme.css";

const TOUR_PREFIX = "sr_tour_seen_";

export const hasSeenTour = (tourName) => {
  return localStorage.getItem(`${TOUR_PREFIX}${tourName}`) === "true";
};

export const markTourSeen = (tourName) => {
  localStorage.setItem(`${TOUR_PREFIX}${tourName}`, "true");
};

const isTouchDevice =
  "ontouchstart" in window || navigator.maxTouchPoints > 0;

export const createTour = (tourName, steps) => {
  // Filter steps to only those whose target element exists in the DOM
  const activeSteps = steps.filter((step) => {
    if (!step.element) return true; // Steps without element (e.g. welcome) always show
    return document.querySelector(step.element);
  });

  if (activeSteps.length === 0) return null;

  const driverInstance = driver({
    showProgress: true,
    // Disable animation on touch devices to avoid driver.js focus() crashes on iOS WebKit
    animate: !isTouchDevice,
    smoothScroll: !isTouchDevice,
    stagePadding: 12,
    stageRadius: 14,
    popoverOffset: 14,
    steps: activeSteps,
    onDestroyed: () => {
      markTourSeen(tourName);
    },
  });

  return driverInstance;
};
